/**
 * Minified by jsDelivr using Terser v5.39.0.
 * Original file: /npm/marked@18.0.0/lib/marked.umd.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
